import { useMemo } from "react";
import LeaderboardTopFive from "./table/LeaderboardTopFive";
import LeaderboardTable from "./table/LeaderboardTable";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { getWinRateColor } from "@ugg/shared/utils/win-rates";
import { getProfileOverviewUrl } from "@ugg/shared/routes/app-routes";
import { LeaderboardData } from "@ugg/shared/api/requests/leaderboards/leaderboard-page";
import { LeaderboardPlayerPlus } from "@ugg/shared/interfaces/leaderboards.interface";

interface LeaderboardTableContainerProps {
  page: number;
  data: LeaderboardData["leaderboardPage"] | undefined | null;
}

export function LeaderboardTableContainer(props: LeaderboardTableContainerProps) {
  const { page, data } = props;
  const queryParams = useQueryString();
  const { region } = queryParams;

  const { players, topPlayerMostPlayedChamp, totalPlayerCount } = data || {};

  const tableData: {
    topFive: LeaderboardPlayerPlus[];
    remainingData: LeaderboardPlayerPlus[];
    firstEntryRanking: number;
    lastEntryRanking: number;
  } = useMemo(() => {
    const currentData = (players || []).map((player) => {
      const totalGamesPlayed = parseInt(player.wins || "0") + parseInt(player.losses || "0");
      const winRate = Math.round((parseInt(player.wins || "0") / totalGamesPlayed) * 100);
      const winRateColor = getWinRateColor(winRate).toLowerCase() === "#ffffff" ? "#cddcfe" : getWinRateColor(winRate);
      const profileURL = getProfileOverviewUrl(region, player.riotUserName, player.riotTagLine);

      return {
        ...player,
        profileURL,
        totalGamesPlayed,
        winRate,
        winRateColor,
      };
    });

    const topFive = page === 1 ? currentData.slice(0, 5) : [];
    const remainingData = page === 1 ? currentData.slice(5) : currentData;
    const firstEntryRanking = (remainingData[0] && remainingData[0].overallRanking) || 0;
    const lastEntryRanking =
      (remainingData[remainingData.length - 1] && remainingData[remainingData.length - 1].overallRanking) || 0;
    return { topFive, remainingData, firstEntryRanking, lastEntryRanking };
  }, [page, data]);

  return (
    <div className="leaderboard_table-container">
      {page === 1 && tableData.topFive.length === 5 && (
        <LeaderboardTopFive data={tableData.topFive} topPlayerMostPlayedChamp={topPlayerMostPlayedChamp || 0} />
      )}
      <LeaderboardTable page={page} totalCount={totalPlayerCount || 0} tableData={tableData} showRegion={true} />
    </div>
  );
}
